<form #availableInternshipForm="ngForm" (ngSubmit)="onSubmit(availableInternshipForm)">
  <div class="bottom">
    <div class="header">
      <div class="title">
        <h1>{{ 'available-internship-dialog.create-title' | translate }}</h1>
      </div>
      <div class="close">
        <mat-icon (click)="onCancel()" [attr.aria-label]="'common.close' | translate">close</mat-icon>
      </div>
    </div>

    <app-alert-message></app-alert-message>

    <div class="content">
      <div class="content-information">
        <label>{{ 'internship-dialog.fields.internship-title' | translate }}</label>
        <input type="text" placeholder="{{ 'available-internship-dialog.placeholders.title' | translate }}" name="internshipsTitle" ngModel required>
      </div>

      <div class="content-information">
        <label>{{ 'available-internships.visibility.label' | translate }}</label>
        <select name="status" ngModel required>
          <option value="" disabled selected>{{ 'available-internship-dialog.select-visibility' | translate }}</option>
          <option value="true">{{ 'available-internships.visibility.enabled' | translate }}</option>
          <option value="false">{{ 'available-internships.visibility.disabled' | translate }}</option>
        </select>
      </div>

      <div class="content-information">
        <label>{{ 'internships.table.position' | translate }}</label>
        <input type="text" placeholder="{{ 'internship-dialog.placeholders.position' | translate }}" name="position" ngModel required>
      </div>

      <div class="content-information">
        <label>{{ 'internship-dialog.fields.department' | translate }}</label>
        <input type="text" placeholder="{{ 'internship-dialog.placeholders.department' | translate }}" name="department" ngModel required>
      </div>

      <div class="content-information">
          <label>{{ 'profile.country' | translate }}</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select placeholder="{{ 'profile.select-country' | translate }}" [(ngModel)]="selectedCountry" 
                        [compareWith]="compareCountries" (selectionChange)="onCountryChange()" 
                        name="country" required>
              <mat-option *ngFor="let country of countries" [value]="country">
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="content-information">
          <label>{{ 'profile.city' | translate }}</label>
          <mat-form-field appearance="outline" class="full-width" [class.disabled]="!selectedCountry">
            <input matInput placeholder="{{ 'profile.select-city' | translate }}" [(ngModel)]="citySearch" 
                   (input)="onCityInput($any($event.target).value)" [matAutocomplete]="cityAuto"
                   [disabled]="!selectedCountry" name="city">
            <mat-autocomplete #cityAuto="matAutocomplete" (optionSelected)="onCitySelected($event.option.value)" [displayWith]="displayCityFn" autoActiveFirstOption>
              <mat-option *ngFor="let city of filteredCities" [value]="city">{{ city.name }}</mat-option>
              <mat-option *ngIf="filteredCities.length === 0" disabled>{{ 'profile.no-cities-found' | translate }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

      <div class="content-information">
        <label>{{ 'available-internship-dialog.fields.internship-email' | translate }}</label>
        <input type="text" placeholder="{{ 'available-internship-dialog.placeholders.internship-email' | translate }}" name="email" [(ngModel)]="email" required>
      </div>

    </div>

    <div class="content-information description-container">
      <label>{{ 'internship.description' | translate }}</label>
      <textarea placeholder="{{ 'available-internship-dialog.placeholders.description' | translate }}" name="description" [(ngModel)]="description" maxlength="{{limitDescription}}" (input)="autoResizeTextarea($event)" class="description-textarea"></textarea>
      <p class="char-count">{{description.length}}/{{limitDescription}}</p>
    </div>
  </div>

  <div class="pulsanti">
    <button class="saveButton" type="submit">
      <mat-icon>save</mat-icon>{{ 'common.save' | translate }}
    </button>
  </div>
</form>
